import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const ATTACH_DOCUMENTS_TO_DEDUCTION = gql`
  ${DEDUCTION_FRAGMENT}
  mutation AttachDocument($params: AttachDeductionDocumentsParams!) {
    attachDocument(params: $params) {
      ...DeductionFields
    }
  }
`;

export default ATTACH_DOCUMENTS_TO_DEDUCTION;
